'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';
import {useOverflow} from 'use-overflow';

interface Props {
  id: string;
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
}

const Swiper = forwardRef(({ slides, className, wrapperClassName, swiperProps, swiperSlideProps, id }: Props, ref: any) => {
  return (
    <div className={twMerge('flex flex-col w-full h-full gap-y-[16px] desktop:gap-y-0 desktop:px-[16px] relative', wrapperClassName)}>
      <SwiperJS
        // dir='rtl'
        modules={[Pagination]}
        uniqueNavElements={false}
        slidesPerView={1}
        breakpoints={{
          0: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 3
          }
        }}
           pagination={
          {
            dynamicBullets: true,
            dynamicMainBullets: 1,
            el: `.swiper-custom-pagination-${id}`,
            type: 'bullets',
            clickable: true,
            // bulletActiveClass: 'bg-secondary',
            bulletClass: `swiper-pagination-bullet-${id}`,
          }
        }
        style={{
          // @ts-ignore
          "--swiper-navigation-color": "black",
          "--swiper-navigation-size": "30px",
        }}
        {...swiperProps}

        className={twMerge('w-full !relative', swiperProps?.className)}
        wrapperClass={twMerge(className)}
        ref={ref}
      >
        {slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className={twMerge('h-full [&>*]:h-full tablet:pl-[24px] pb-[10px] desktop:pb-0', swiperSlideProps?.className)}>{s}</SwiperSlide>)}
      </SwiperJS>
<div className={`!h-[25px] !w-full !flex !items-center [&>*]:!scale-100 [&>*]:opacity-50 [&>.swiper-pagination-bullet-active]:!opacity-100 [&>.swiper-pagination-bullet-active]:!bg-primary [&>.swiper-pagination-bullet-active]:!h-[12px] [&>.swiper-pagination-bullet-active]:!w-[12px] !justify-center [&>*]:!bg-gray-400 dark:[&>*]:!bg-white [&>*]:!h-[6px] [&>*]:!w-[6px] [&>*]:aspect-square gap-x-[24px] [&>*]:rounded-full swiper-custom-pagination-${id}`}></div> 

 </div>

)
});


export default Swiper;